import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { GbpReviewDetailDrawerComponent } from '../reviews/review-detail-drawer.component';

@Component({
  selector: 'app-local-actions-queue',
  templateUrl: './actions-queue-page.component.html',
  styleUrls: ['./actions-queue-page.component.css'],
})
export class LocalActionsQueueComponent implements OnInit {
  url: string = 'localActions';
  data: Array<any> = [];
  state: string = 'pending_approval';
  priority: string = '';

  currentPage: number = 1;
  totalPages: number = 1;
  limit: number = 20;
  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    public router: Router,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    let query = `?page=${this.currentPage}&limit=${this.limit}`;
    if (this.state) query += `&state=${this.state}`;
    if (this.priority) query += `&priority=${this.priority}`;

    this.dataService.getData(this.url + query).subscribe((response) => {
      if (response && response.rst) {
        this.data = response.data;
        this.totalPages = response.pages;
      }
    });
  }

  setState(state: string) {
    this.state = state;
    this.currentPage = 1;
    this.getData();
  }

  openAction(action: any) {
    const dialogRef = this.dialog.open(GbpReviewDetailDrawerComponent, {
      width: '600px',
      position: { right: '0' },
      height: '100vh',
      panelClass: 'side-drawer',
      data: { review: action.entity.reviewId }, // Pass the reviewId, the drawer will load details
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getData();
    });
  }

  changePage(page: number) {
    this.currentPage = page;
    this.getData();
  }
}
